import { BN, Program } from '@coral-xyz/anchor';
import { TOKEN_PROGRAM_ID } from '@solana/spl-token';
import { PublicKey, SystemProgram } from '@solana/web3.js';
import { IDL } from './paymentRouter';
class PaymentRouterProgram {
    static async createPaymentRouterBalancePdaInstruction(paymentRouterPda, payer, programId = PaymentRouterProgram.programId) {
        const program = new Program(IDL, programId);
        return await program.methods
            .createPaymentRouterBalancePda()
            .accounts({
            paymentRouterPda,
            payer,
            systemProgram: SystemProgram.programId
        })
            .instruction();
    }
    static async createRouteInstruction({ sender, senderOwner, paymentRouterPdaBump, recipients, amounts, totalAmount, tokenProgramId = TOKEN_PROGRAM_ID, programId = PaymentRouterProgram.programId }) {
        const program = new Program(IDL, programId, {});
        return await program.methods
            .route(paymentRouterPdaBump, amounts.map((b) => new BN(b.toString())), new BN(totalAmount.toString()))
            .accounts({
            sender,
            senderOwner,
            splToken: tokenProgramId
        })
            .remainingAccounts(recipients.map((recipient) => ({
            pubkey: recipient,
            isSigner: false,
            isWritable: true
        })))
            .instruction();
    }
}
PaymentRouterProgram.programId = new PublicKey('paytYpX3LPN98TAeen6bFFeraGSuWnomZmCXjAsoqPa');
export { PaymentRouterProgram };
//# sourceMappingURL=PaymentRouterProgram.js.map